import React from "react";
import { Container, Row, Col, Table, Card, Placeholder, Badge } from "react-bootstrap";
import { HeadPage } from "src/componentes";
import NFCeVisualizaCode from "./NFCe.Visualiza.Code";
import moment from "moment";
import { meioPagamento } from "../NFCe.Dto";

const NFCeVisualizaView = () => {
  const code = NFCeVisualizaCode();
  const nfce = code.nfce;

  if (code.loading) {
    return (
      <Container>
        <HeadPage headText="Visualizar NFCe" />
        <Placeholder animation="glow" className="mt-4">
          <Placeholder xs={12} size="lg" />
          <Placeholder xs={12} className="mt-2" />
          <Placeholder xs={12} className="mt-2" />
        </Placeholder>
      </Container>
    );
  }

  if (!nfce) {
    return (
      <Container>
        <HeadPage headText="Visualizar NFCe" />
        <div className="text-center mt-5">
          <h4>NFCe não encontrada</h4>
        </div>
      </Container>
    );
  }

  return (
    <Container className="pb-5 container-print">
      <div className="no-print">
        <HeadPage headText={`NFCe: ${nfce.numeroNF} / Série: ${nfce.serie}`} />
      </div>

      {/* Cabeçalho */}
      <Card className="mt-4 border-0">
        <Card.Body>
          <Card.Title className="mb-3 text-primary">Dados Gerais</Card.Title>
          <Row>
            <Col xs={12} md={4} className="mb-2">
              <strong>Número:</strong> {nfce.numeroNF}
            </Col>
            <Col xs={12} md={4} className="mb-2">
              <strong>Série:</strong> {nfce.serie}
            </Col>
            <Col xs={12} md={4} className="mb-2">
              <strong>Emissão:</strong> {nfce.emissaoDataHora ? moment(nfce.emissaoDataHora).format("DD/MM/YYYY HH:mm:ss") : "N/A"}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12}>
              <strong>URL QR Code:</strong> <small className="text-break">{nfce.autorizacao?.urlQrCode || "N/A"}</small>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Itens */}
      <Card className="mt-4 border-0">
        <Card.Body>
          <Card.Title className="mb-3 text-primary">Itens</Card.Title>
          <Table responsive hover className="mb-0">
            <thead>
              <tr>
                <th>Seq</th>
                <th>Cód. Produto</th>
                <th>Descrição</th>
                <th className="text-end">Qtd</th>
                <th className="text-end">Vlr. Unit</th>
                <th className="text-end">Vlr. Total</th>
              </tr>
            </thead>
            <tbody>
              {nfce.itens?.map((item, index) => (
                <React.Fragment key={index}>
                  <tr 
                    onClick={() => code.toggleItemExpansion(index)} 
                    style={{ cursor: "pointer" }}
                    className={code.expandedItemIndex === index ? "table-active" : ""}
                  >
                    <td>{item.sequencia}</td>
                    <td>{item.codigoProduto}</td>
                    <td>{item.nome}</td>
                    <td className="text-end">{item.quantidadeComercial.toFixed(4)}</td>
                    <td className="text-end">{item.valorUnitarioComercial.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    <td className="text-end">{item.valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                  </tr>
                  {code.expandedItemIndex === index && (
                    <tr>
                      <td colSpan={6} className="p-0">
                        <div className="p-3 border-top">
                          <h6 className="text-secondary mb-3">Detalhes de Impostos (ICMS)</h6>
                          {item.icms ? (
                            <Row>
                              <Col xs={12} sm={6} md={3} className="mb-2">
                                <strong>CST:</strong> <Badge bg="secondary">{item.icms.cst}</Badge>
                              </Col>
                              <Col xs={12} md={6} className="mb-2">
                                <strong>Origem:</strong> {item.icms.origem} - {item.icms.origemDescricao}
                              </Col>
                              <Col xs={12} sm={6} md={3} className="mb-2">
                                <strong>BC ICMS:</strong> {item.icms.valorBC.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                              </Col>
                              <Col xs={12} sm={6} md={3} className="mb-2">
                                <strong>Vlr ICMS:</strong> {item.icms.valorICMS.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                              </Col>
                              <Col xs={12} sm={6} md={3} className="mb-2">
                                <strong>% ICMS:</strong> {item.icms.percentualICMS}%
                              </Col>
                              <Col xs={12} sm={6} md={3} className="mb-2">
                                <strong>CFOP:</strong> {item.cfop}
                              </Col>
                              <Col xs={12} sm={6} md={3} className="mb-2">
                                <strong>NCM:</strong> {item.codigoNCM}
                              </Col>
                            </Row>
                          ) : (
                            <div className="text-muted italic">Dados de tributação não disponíveis para este item.</div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Pagamento */}
      <Card className="mt-4 border-0">
        <Card.Body>
          <Card.Title className="mb-3 text-primary">Pagamento</Card.Title>
          <Table responsive className="mb-0">
            <thead>
              <tr>
                <th>Meio de Pagamento</th>
                <th className="text-end">Valor</th>
              </tr>
            </thead>
            <tbody>
              {nfce.pagamento?.map((p) => (
                <tr key={p.id}>
                  <td>
                    {meioPagamento.find(mp => mp.meioPagamento === p.meioPagamento)?.descricaoPagamento || "Outros"}
                  </td>
                  <td className="text-end">{p.valorPagamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Totalizadores */}
      <Card className="mt-4 border-0">
        <Card.Body>
          <Card.Title className="mb-3 text-primary">Totalizadores</Card.Title>
          <Row>
            <Col xs={12} md={3} className="mb-3">
              <div className="p-3 border rounded text-center">
                <div className="text-dark small">Valor Produtos</div>
                <div className="h5 mb-0">{nfce.total?.valorProduto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
              </div>
            </Col>
            <Col xs={12} md={3} className="mb-3">
              <div className="p-3 border rounded text-center">
                <div className="text-dark small">Total Desconto</div>
                <div className="h5 mb-0 text-danger">{nfce.total?.valorDesconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
              </div>
            </Col>
            <Col xs={12} md={3} className="mb-3">
              <div className="p-3 border rounded text-center">
                <div className="text-dark small fw-bold">VALOR TOTAL NOTA</div>
                <div className="h4 mb-0 fw-bold">{nfce.total?.valorNotaFiscal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
              </div>
            </Col>
            <Col xs={12} md={3} className="mb-3">
              <div className="p-3 border rounded text-center">
                <div className="text-dark small">Troco</div>
                <div className="h5 mb-0 text-success">{nfce.total?.valorTroco.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Autorização */}
      <Card className="mt-4 border-0">
        <Card.Body>
          <Card.Title className="mb-3 text-primary">Autorização / Sefaz</Card.Title>
          <Row>
            <Col xs={12} className="mb-3">
              <strong>Chave de Acesso:</strong>
              <div className="font-monospace mt-1">{nfce.autorizacao?.chaveAcesso || "N/A"}</div>
            </Col>
            <Col xs={12} sm={6} md={4} className="mb-2">
              <strong>Status:</strong> <Badge bg={nfce.autorizacao?.codigoStatusResposta === 100 ? "success" : "warning"}>{nfce.autorizacao?.codigoStatusResposta} - {nfce.autorizacao?.descricaoMotivoResposta}</Badge>
            </Col>
            <Col xs={12} sm={6} md={4} className="mb-2">
              <strong>Protocolo:</strong> {nfce.autorizacao?.numeroProtocolo || "N/A"}
            </Col>
            <Col xs={12} sm={6} md={4} className="mb-2">
              <strong>Envio:</strong> {nfce.autorizacao?.descricaoStatusEnvio}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NFCeVisualizaView;
